import {
    EDIT_EMPLOYEE_CTC_REQUEST,
    EDIT_EMPLOYEE_CTC_SUCCESS,
    EDIT_EMPLOYEE_CTC_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editEmployeeCtcReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_EMPLOYEE_CTC_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case EDIT_EMPLOYEE_CTC_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_EMPLOYEE_CTC_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default editEmployeeCtcReducer;
